import React, { useContext, useEffect, useMemo, useState } from 'react';
import ShareableLinkDataContext from './ShareableLinkData.context';
import ShareableLinkContext from '../ShareableLink/ShareableLink.context';
import shareableLinks from '../../api/shareable-links';
import { DataRoomShareableLink } from 'models/ShareableLink';
import { Navigate, useParams } from 'react-router-dom';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import FourDotLoader from 'components/FourDotLoader';
import { BUSINESS_ROUTE } from 'data/global';
import HelmetWrapper from 'components/HelmetWrapper';
import { useTranslation } from 'react-i18next';
import useBrandingColors from 'hooks/useBrandingColors';

const ShareableLinkDataProvider: React.FC = (props) => {
  const { children } = props;

  const [isLoading, setIsLoading] = useState(true);
  const [shareableLink, setShareableLink] = useState<DataRoomShareableLink>();

  const { isLoggedIn } = useContext(ShareableLinkContext);
  const { popServerError } = useContext(PopNotificationsContext);

  const { shareableLinkId } = useParams<{ shareableLinkId: string }>();

  const brandingColors = useMemo(
    () => ({
      primaryColor: shareableLink?.dataRoom?.primaryColor,
      secondaryColor: shareableLink?.dataRoom?.secondaryColor,
    }),
    [
      shareableLink?.dataRoom?.primaryColor,
      shareableLink?.dataRoom?.secondaryColor,
    ],
  );

  const { t } = useTranslation();

  useEffect(() => {
    if (!isLoggedIn) return;

    (async () => {
      try {
        setIsLoading(true);
        const { data } = await shareableLinks.getShareableLink(shareableLinkId);

        setShareableLink(data);
      } catch (e) {
        popServerError(e);
      } finally {
        setIsLoading(false);
      }
    })();
  }, [isLoggedIn, shareableLinkId, popServerError]);

  useBrandingColors(brandingColors);

  if (!isLoggedIn) return null;

  if (isLoading) return <FourDotLoader />;

  if (!shareableLink) return <Navigate to={BUSINESS_ROUTE} replace />;

  return (
    <ShareableLinkDataContext.Provider
      value={{
        shareableLink,
      }}
    >
      <HelmetWrapper title={`${t('secureShare')} - ${shareableLink?.name}`} />
      {children}
    </ShareableLinkDataContext.Provider>
  );
};

export default ShareableLinkDataProvider;
